import {Select as AntSelect} from 'antd';
import styled from 'styled-components';

const Select = styled(AntSelect)`
  flex-basis: 150px;

  .ant-select-arrow .anticon {
    display: none !important;
  }

  .ant-select-arrow::after {
    content: '';
    display: inline-block;
    width: 8px;
    height: 4px;
    background: #fff;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    /* 用 clip-path 畫倒三角 */
    clip-path: polygon(50% 100%, 0 0, 100% 0);
    background-color: #39383a; /* 你圖示的顏色 */
  }
`;

// 確保 Option 也被正確導出
Select.Option = AntSelect.Option;

export default Select;
